module.exports = __webpack_public_path__ + "img/370eb5c6e16b24b72b14e908021283aa.svg";